exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1O1bTkGeGmJ0ig792_grN_ {\n  position: fixed;\n  cursor: pointer;\n  top: -9px;\n  left: -6px;\n}\n\n._2HZKDoGwdDUKM4RmyGN7Hb {\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.Hg4BKuLh1y0RjiVHwWA4A {\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n._1mEs6bTtn7USYayrhcCNRR {\n  padding-top: 35px;\n}\n", ""]);

// exports
exports.locals = {
	"alertClose": "_1O1bTkGeGmJ0ig792_grN_",
	"alertHeaderText": "_2HZKDoGwdDUKM4RmyGN7Hb",
	"alertBodyContent": "Hg4BKuLh1y0RjiVHwWA4A",
	"alertIcon": "_1mEs6bTtn7USYayrhcCNRR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/Common/AlertModal/AlertModal.css
// module id = 9786
// module chunks = 23